import fetch from '@/utils/fetch'
import { NVWA_URL, TEMP_URL, IS_DEV } from '../../shared/constant'
import { FormConfigData, SourceTypes } from '@/typings/types'
const redisPrefix = 'activity_detail_'

import logger from '../../server/logger'

let redis = null
if (typeof window === 'undefined') {
  // node 且非dev
  redis = typeof global !== undefined && global.redisClient
  console.error('use global.redisClient')
  if (!redis) {
    redis = require('../../server/redis').client
  }
}

interface ResDataType<T> {
  data: T
  code: number
  msg: string
  source: string
}

function resWrapper<T>(data: T): ResDataType<T> {
  if (typeof data === 'string') {
    data = JSON.parse(data)
  }
  return {
    code: 0,
    data,
    msg: '成功',
    source: 'cdn',
  }
}

interface BaseFormConfigData {
  active: boolean
  createTime: number
  describe: string
  projectName: any
  status: any
  title: any
  type: any
  updateTime: number
  _id: string
}

interface ResType extends BaseFormConfigData {
  data: FormConfigData
  previewData: FormConfigData
}

interface ResTypeNotFormat extends BaseFormConfigData {
  data: string
  previewData: string
}

export type SelfResDataType = ResDataType<ResType>

function formatResData(res: ResTypeNotFormat): ResType {
  return {
    ...res,
    data: JSON.parse(res.data) as FormConfigData,
    previewData: JSON.parse(res.data) as FormConfigData,
  }
}

// 无兜底
async function fetchDataFromRedis(id) {
  const res = await redis.get(`${redisPrefix}${id}`)
  if (res) {
    logger('获取Redis-json成功').log(`id为:${id}`)
    return resWrapper(formatResData(JSON.parse(res) as any))
  } else {
    const msg = `获取Redis-json失败，当前id:${id}无数据`
    logger('获取Redis-json失败').error(`id为:${id}`)
    throw new Error(msg)
  }
}

async function fetchDataFromCdn(id: string): Promise<SelfResDataType> {
  const env = ['pro', 'pre'].includes(process.env.SENV) ? '' : 'test/'
  const timeStamp = new Date().getTime()
  try {
    const resp = await fetch.fetch(
      `https://cdn.poizon.com/node-common/${env}${id}?timeStamp=${timeStamp}`
    )
    const res = await resp.json()
    return resWrapper(formatResData(res))
  } catch (error) {
    return {
      code: 0,
      data: {
        updateTime: 0,
        _id: '',
        data: {
          componentList: [],
          globalConfig: {
            pinxuanShow: false,
            style: {},
            statusBarStyle: 0,
            buttonColor: '',
            colorMode: 0,
            hideNavigation: 0,
            title: '',
            share: {},
          },
          share: {},
        },
        projectName: '',
        status: '',
        title: '',
        type: '',
        previewData: {
          componentList: [],
          globalConfig: {
            pinxuanShow: false,
            style: {},
            statusBarStyle: 0,
            buttonColor: '',
            colorMode: 0,
            hideNavigation: 0,
            title: '',
            share: {},
          },
          share: {},
        },
        active: false,
        createTime: 1,
        describe: '',
      },
      msg: '成功',
      source: 'cdn',
    }
  }
}

export async function getCdnData(id: string): Promise<SelfResDataType> {
  let res: any = null
  // node上的请求redis
  if (redis) {
    try {
      res = await fetchDataFromRedis(id)
    } catch (error) {
      logger('获取Redis-json失败').error(`id为:${id}`)
      res = await fetchDataFromCdn(id)
    }
  } else {
    try {
      res = await fetchDataFromCdn(id)
      // res = formatResData(res)
    } catch (error) {
      res = await fetch.get({
        url: `${NVWA_URL || ''}/api/nvwa/detail/${id}`,
      })
      res = await res.json()
      res = resWrapper(formatResData(res.data))
      console.error(res, 'resresresres')
    }
  }
  return res
}

export async function getNodeData(id: string): Promise<SelfResDataType> {
  let res: any = null
  try {
    res = await fetch.get({
      url: `${NVWA_URL || ''}/api/nvwa/detail/${id}`,
    })
    if (res.code !== 0) {
      throw new Error('node 请求失败')
    }
  } catch (error) {
    res = await fetchDataFromCdn(id)
  }
  return res
}

export async function getActivityDetail(id: string, source: SourceTypes): Promise<SelfResDataType> {
  if (source === SourceTypes.fromCDN) {
    return await getCdnData(id)
  } else if (source === SourceTypes.fromNode) {
    return await getNodeData(id)
  }
  return await fetchDataFromCdn(id)
}

export async function getCouponList(templateId: string): Promise<any> {
  let res: any = null
  res = await fetch.post({
    url: `${TEMP_URL || ''}/api/v1/h5/glocal-admin/coupon/lookup`,
    data: { templateId },
  })
  return res
}

export async function saveCouponActivity(data: {
  id: number
  language: string
  marketType: number
  region: string
  templateIds: Array<number>
  uniqueMark: string
}): Promise<any> {
  let res: any = null
  res = await fetch.post({
    url: `${TEMP_URL || ''}/api/v1/h5/glocal-admin/coupon-activity/save`,
    data,
  })
  return res
}

export async function getUploadGoods(data: {
  fileUrl: number
  language?: string
  region?: string
}): Promise<any> {
  let res: any = null
  res = await fetch.post({
    url: `${TEMP_URL || ''}/api/v1/h5/adapter/commodityFlow/fileImport`,
    data,
  })
  return res
}
